// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as ServiceAreasRouteImport } from './routes/service-areas'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ServiceAreasIndexRouteImport } from './routes/service-areas.index'
import { Route as ServiceAreasSlugRouteImport } from './routes/service-areas.$slug'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const ServiceAreasRoute = ServiceAreasRouteImport.update({
            id: '/service-areas',path: '/service-areas',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ServiceAreasIndexRoute = ServiceAreasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServiceAreasRoute
          })
const ServiceAreasSlugRoute = ServiceAreasSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ServiceAreasRoute
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ServicesRoute
          })





const ServiceAreasRouteChildren = {
  ServiceAreasSlugRoute: ServiceAreasSlugRoute,ServiceAreasIndexRoute: ServiceAreasIndexRoute
}

const ServiceAreasRouteWithChildren = ServiceAreasRoute._addFileChildren(ServiceAreasRouteChildren)




const ServicesRouteChildren = {
  ServicesSlugRoute: ServicesSlugRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,GalleryRoute: GalleryRoute,ServiceAreasRoute: ServiceAreasRouteWithChildren,ServicesRoute: ServicesRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)